import { Link } from "react-router-dom";
import { TriangleAlert } from "lucide-react";

export default function ({ message }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <div className="text-center">
          <TriangleAlert className="mx-auto h-12 w-12 text-red-500" aria-hidden />
          <h2 className="mt-2 text-h5 font-semibold text-gray-900">
            Invalid Invitation
          </h2>
          <p className="mt-2 text-small text-gray-600">{message}</p>
        </div>
        <div className="mt-6">
          <Link
            href="/"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-small font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
